/* Rquiere de mixin.js */

var church = {
	data () {
		return {
			listChurchs: [],
			listChurchsGenesys: [],
			listChurchClient: [],
			loadingChurchs: false,
			methodsChurch: {
				get: 'churchs',
				show: 'church/',
				create: 'church/register',
			},
			paginationChurchs: [],
			searchChurchs: '',
			objectChurch: {
				exists: 0,
				id: 0,
				name: '',
				synthetic: '',
				district: {},
				entity: {},
				type_church: {},
				updated_at: '',
				created_at: '',
				genesys: {},
				client: {}
			},
			qRowsChurch: 25
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		changeQRowsChurch() {
            localStorage.setItem('qRowsChurch', this.qRowsChurch)
            this.getAllChurchs()
        },
        clearObjectChurch() {
            this.objectChurch.exists = 0
            this.objectChurch.id = 0
            this.objectChurch.name = ''
            this.objectChurch.synthetic = ''
            this.objectChurch.district = {}
            this.objectChurch.entity = {}
            this.objectChurch.type_church = {}
            this.objectChurch.client = {}
            this.objectChurch.updated_at = ''
            this.objectChurch.updated_at = ''
        },
		getAllChurchs(page = 1, all = 0) {
			this.loadingChurchs = true
			this.listChurchs = []
			this.paginationChurchs = []
			let parameters = '?search=' + this.searchChurchs + '&page=' + page
			parameters = (all == 0) ? parameters + '&qRow=' + this.qRowsChurch : parameters
			let url = this.apiBackend + this.methodsChurch.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllChurchsResult')
        },
        getAllChurchsResult(response) {
			this.loadingChurchs = false
			if(response.data.success == true) {
				this.listChurchs = response.data.data
				this.paginationChurchs = response.data.paginate
			}
            this.getAllChurchsResultLocal(response)
        },
        getAllChurchsResultLocal(response) {
            console.log('getAllChurchsResultLocal no desarrollado', response)
        },
		getAllChurchClients(id) {
			this.listChurchClient = []
			let url = this.apiBackend + this.methodsChurch.show + id + '/clients'
			this.axiosActionIS(url, 'GET', 'getAllChurchClientsResult')
		},
		getAllChurchClientsResult(response) {
			if(response.data.success == true) {
				this.listChurchClient = response.data.data
			}
			this.getAllChurchClientsResultLocal(response)
		},
		getAllChurchClientsResultLocal(response) {
			console.log('getAllChurchClientsResultLocal no desarrollado', response)
		},
		getAllChurchsGenesys(search) {
			this.listChurchsGenesys = []
			let param = {
				get: 'cliente/getByCode?search=' + search
			}
			let url = this.apiBackend + 'genesys/get'
			this.axiosActionIS(url, 'POST', 'getAllChurchsGenesysResult', param)
		},
		getAllChurchsGenesysResult(response) {
			if(response.data.status == 200) {
				this.listChurchsGenesys = response.data.data
			}
			this.getAllChurchsGenesysResultLocal(response)
		},
		getAllChurchsGenesysResultLocal(response) {
			console.log('getAllChurchsGenesysResultLocal no desarrollado', response)
		},
		setObjectChurch(item) {
			for (const property in item) {
				this.objectChurch[property] = item[property]
			}
        },
		saveChurch(item) {
			let method = (item == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if(method == 'POST') {
				this.axiosActionIS(this.apiBackend + this.methodsChurch.create, method, 'saveChurchResult', item)
			} else {
				this.axiosActionIS(this.apiBackend + this.methodsChurch.show + item.id, method, 'saveChurchResult', item)
            }
		},
		saveChurchResult(response) {
			if(response.data.success == true) {
				this.setObjectChurch(response.data.data)
			}
			this.saveChurchResultLocal(response)
		},
		saveChurchResultLocal(response) {
			console.log('saveChurchResultLocal no desarrollado', response)
		},
		saveChurchGenesys(id, clicod) {
			let param = {
				clicod: clicod
			}
			let url = this.apiBackend + this.methodsChurch.show + id + '/genesys/register'
			this.axiosActionIS(url, 'POST', 'saveChurchGenesysResult', param)
		},
		saveChurchGenesysResult(response) {
			this.saveChurchGenesysResultLocal(response)
		},
		saveChurchGenesysResultLocal(response) {
			console.log('saveChurchGenesysResultLocal no desarrollado', response)
		},
		setChurchInit() {
			this.qRowsChurch = (localStorage.getItem('qRowsChurch') === null) ? this.qRowsChurch : localStorage.getItem('qRowsChurch')
			this.setChurchInitLocal()
		},
		setChurchInitLocal() {

		},
		showChurch(id) {
			this.clearObjectChurch()
			this.axiosActionIS(this.apiBackend + this.methodsChurch.show + id, 'GET', 'showChurchResult')
		},
		showChurchResult(response) {
			if(response.data.success === true) {
				this.setObjectChurch(response.data.data)
			}
			this.showChurchResultLocal(response)
		},
		showChurchResultLocal(response) {
			console.log('showChurchResultLocal no desarrollado', response)
		},
		updateItemListChurchs(item) {
			let index = this.listChurchs.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
            if(index > -1) {
                for (const property in item) {
                    this.listChurchs[index][property] = item[property]
                }
            }
            if(this.objectChurch.id == item.id) {
                this.setObjectChurch(item)
            }
        },
		verifyChurchGenesys(id) {
			let url = this.apiBackend + 'church/' + id + '/genesys'
			this.axiosActionIS(url , 'GET', 'verifyChurchGenesysResult')
		},
		verifyChurchGenesysResult(response) {
			this.verifyChurchGenesysResultLocal(response)
		}
	},
};

export default church;